import { AdministrativeCentresModel } from "../contact/administrativeCentres.model";

export class CenterModel {
  uid: string;
  contactUid: string;
  code: string;
  name: string;
  phone: string;
  email: string;
  address: string;
  country: string;
  location: string;
  postalCode: string;
  state: string;
  administrativeCentres: Array<AdministrativeCentresModel>;
}
